"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = require("prop-types");
var _constant = require("../Theme/constant");
var _theme = _interopRequireDefault(require("../Theme/lib/AirasiaClassic/theme"));
var _constant2 = require("./constant");
var _default = {
  PropTypes: {
    theme: _propTypes.string,
    accessible: _propTypes.bool,
    status: (0, _propTypes.oneOf)(Object.values(_constant2.FLATBED_STATUS)).isRequired,
    size: (0, _propTypes.oneOf)(Object.keys(_theme.default.fontSize)).isRequired,
    centerText: _propTypes.string,
    onClick: _propTypes.func
  },
  DefaultProps: {
    theme: _constant.DEFAULT_THEME,
    accessible: true,
    status: _constant2.FLATBED_STATUS.AVAILABLE,
    size: 'titleLarge',
    onClick: function onClick() {}
  }
};
exports.default = _default;